import { isNotNullish } from '@adornis/assert/isNullish.js';
import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';

export const inclusiveInterval =
  (min: number, max: number, props?: { translationKey?: string; allowFalsy?: boolean }) => options => {
    if (!props?.allowFalsy && !options.value) return;
    if (isNotNullish(options.value) && (options.value >= max || options.value < min))
      throw new ValidationError(
        `Wert des Feldes "${
          clientTranslator.translate('field', options.key) as string
        }" muss im Intervall ${min} - ${max} liegen!`,
        {
          key: options.key,
          translationKey: props?.translationKey,
          path: options.path,
        },
      );
  };
